
export default {
  // Airport-related translations
  "loading_leaderboard": "Loading leaderboard...",
  "no_reviews_yet": "No reviews yet",
  "be_first": "Be the first to review an airport!",
  "best_airports": "Best Airports",
  "worst_airports": "Worst Airports",
  "success_rate": "Success Rate",
  "airport_name": "Airport Name",
  "airport_location": "Location",
  "score": "Score",
  "total_reviews": "Reviews",
  "bottom_10_airports": "Bottom 10 airports based on film photographer reviews",
  "top_10_airports": "Top 10 airports based on film photographer reviews",
  "rank": "Rank",
  "hand_check_rate": "Hand Check Rate",
  "reviews": "Reviews",
  "loading_airport": "Loading airport details...",
  "airport_not_found": "Airport not found",
  "airport_reviews": "Airport Reviews",
  "no_reviews_yet_share": "No reviews yet",
  "share_film_community": "Share your experience with the film community!",
  "add_review_button": "Add Review",
  "favorite_airports": "Favorite Airports",
  "no_favorite_airports": "No favorite airports yet",
  "user_favorites": "User Favorites",
  "manage_favorites": "Manage Favorites",
  "remove_from_favorites": "Remove from Favorites",
  "add_to_favorites": "Add to Favorites",
  "airport_added_favorites": "Airport added to favorites",
  "airport_removed_favorites": "Airport removed from favorites",
  // Search translations
  "search_results_for": "Search Results for",
  "no_reviews_found": "No reviews found",
  "no_airports_matching": "No airports found matching",
  "sort_newest": "Newest",
  "sort_oldest": "Oldest",
  "sign_in_to_review": "Sign in to add review",
};
